import EurekaWordmark from "@/components/EurekaWordmark";
import { NavLink } from "@/components/NavLink";
interface Props {
  navLinks?: {
    [label: string]: string;
  };
  children?: React.ReactNode;
}
export function NavBar({
  navLinks,
  children
}: Props) {
  return <nav className="w-full flex justify-center border-b border-[#152B6F]/10 h-16" data-sentry-component="NavBar" data-sentry-source-file="NavBar.tsx">
      <div className="w-full flex justify-between items-center px-6 text-sm">
        <EurekaWordmark data-sentry-element="EurekaWordmark" data-sentry-source-file="NavBar.tsx" />
        <div className="flex space-x-4">
          {navLinks && Object.entries(navLinks).map(([label, href]) => <NavLink key={href} href={href}>
                {label}
              </NavLink>)}
        </div>
        {children}
      </div>
    </nav>;
}